import { Component, OnInit, OnDestroy } from '@angular/core';
import { Field } from '../../_models/field';
import { UserProfile } from '../../_models/user-profile';
import { UserProfileService } from '../../_services/user-profile.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { WellsService } from '../../control-panel/_services/wells.service';
import { ActivatedRoute } from '@angular/router';
import { PortalApiService } from '../../_services/portal-api.service';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.css']
})
export class FieldComponent implements OnInit, OnDestroy {
  isLoadingField: boolean = false;
  field: Field;
  userProfile: UserProfile;
  fieldID: number;
  // Notifications:
  errorGetField: string;
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private userService: UserProfileService,
    private apiService: PortalApiService,
    private route: ActivatedRoute
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => {
        this.userProfile = userProfile;
      });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.fieldID = params['fieldID'];
    })
    this.getFields();
  }

  ngOnDestroy() {

  }

  getFields() {
    this.isLoadingField = true;

    if (this.userProfile.id) {
      this.apiService.getFields().subscribe({
        next: (data: Field[]) => {
          //console.log(data);
          this.isLoadingField = false;

          data.map(field => {
            if (field.fieldID == this.fieldID) {
              this.field = field;
            }
          })
        },
        error: err => {
          console.log(err);
          this.errorGetField = (err.error || 'An error occurred. Failed to load field.');
          this.isLoadingField = false;
        }
      });
    }
  }
}
